export type PaymentApp = 'PHONEPE' | 'GPAY' | 'PAYTM';
export type PaymentMethod = PaymentApp | 'DEFAULT';

export const PAYMENT_METHODS: { id: PaymentApp; label: string; icon: string }[] = [
    { id: 'GPAY', label: 'Google Pay', icon: '/google-pay-144.svg' },
    { id: 'PAYTM', label: 'Paytm', icon: '/paytm-144.svg' },
    { id: 'PHONEPE', label: 'PhonePe', icon: '/phonepe-144.svg' }
];

export const APP_CONFIG: Record<string, { icon: string; label: string }> = {
    PHONEPE: { icon: '/phonepe-144.svg', label: 'PhonePe' },
    GPAY: { icon: '/google-pay-144.svg', label: 'Google Pay' },
    PAYTM: { icon: '/paytm-144.svg', label: 'Paytm' },
    DEFAULT: { icon: '/upi-144.svg', label: 'Other UPI' }
};

export const UPI_PACKAGE_NAMES: Record<PaymentApp, string> = {
    PHONEPE: 'com.phonepe.app',
    GPAY: 'com.google.android.apps.nbu.paisa.user',
    PAYTM: 'net.one97.paytm'
};

export const FALLBACK_UPI_ICON = '/upi-144.svg';

export const getAuthorizationAmountForPaymentMethod = (paymentMethod?: string | null) =>
    paymentMethod === 'DEFAULT' || paymentMethod === 'VPA' || !!paymentMethod?.includes('@') ? 1 : 2;
